import { useLayoutEffect } from 'react'

export const PAGE_STYLESHEETS = [
  ['home-page-css', '/css/lighter_home.css'],
  ['trade-page-css', '/css/lighter_trade_LIT.css'],
  ['portfolio-page-css', '/css/lighter_portfolio.css'],
  ['public-pools-page-css', '/css/lighter_public-pools.css'],
  ['staking-page-css', '/css/lighter_staking.css'],
  ['referrals-page-css', '/css/lighter_referrals.css'],
  ['sub-accounts-page-css', '/css/lighter_sub-accounts.css'],
  ['funding-market-risk-page-css', '/css/lighter_funding-market-risk.css'],
]

const ROUTE_SHEETS = [
  ['/trade', 'trade-page-css', '/css/lighter_trade_LIT.css'],
  ['/portfolio', 'portfolio-page-css', '/css/lighter_portfolio.css'],
  ['/public-pools', 'public-pools-page-css', '/css/lighter_public-pools.css'],
  ['/staking', 'staking-page-css', '/css/lighter_staking.css'],
  ['/referrals', 'referrals-page-css', '/css/lighter_referrals.css'],
  ['/sub-accounts', 'sub-accounts-page-css', '/css/lighter_sub-accounts.css'],
  ['/funding-market-risk-parameters', 'funding-market-risk-page-css', '/css/lighter_funding-market-risk.css'],
]

export function pageCssForPath(pathname) {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname || '/'
  if (path === '/' || path === '') {
    return { id: 'home-page-css', href: '/css/lighter_home.css', home: true }
  }
  for (const [prefix, id, href] of ROUTE_SHEETS) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return { id, href, home: false }
    }
  }
  return null
}

const enableCounts = new Map()

function ensureLink(id, href, { disabled }) {
  let link = document.getElementById(id)
  if (!link) {
    link = document.createElement('link')
    link.id = id
    link.rel = 'stylesheet'
    link.href = href
    link.dataset.pageCss = 'true'
    link.disabled = disabled
    document.head.appendChild(link)
  }
  return link
}

export function preloadPageCss() {
  if (typeof document === 'undefined') return
  for (const [id, href] of PAGE_STYLESHEETS) {
    ensureLink(id, href, { disabled: true })
  }
}

function enablePageCss(id, href) {
  const link = ensureLink(id, href, { disabled: false })
  enableCounts.set(id, (enableCounts.get(id) || 0) + 1)
  link.disabled = false
  return link
}

function disablePageCss(id) {
  const next = (enableCounts.get(id) || 1) - 1
  enableCounts.set(id, next)
  queueMicrotask(() => {
    if ((enableCounts.get(id) || 0) > 0) return
    enableCounts.delete(id)
    const existing = document.getElementById(id)
    if (existing) existing.disabled = true
  })
}

export function usePageCss(id, href) {
  useLayoutEffect(() => {
    preloadPageCss()
    enablePageCss(id, href)
    return () => disablePageCss(id)
  }, [id, href])
}
